var React = require('react');
const PropTypes = React.PropTypes; //TODO: react 15.5 -> require( 'prop-types' );

class Provider extends React.Component {
    constructor() {
        super()
        //this._app = AppFactory.getApp()
    }

    render() {
        return this.props.children
    }

    getChildContext() {
        var contextData = {
            //app: this._app
        }

        if (this.props.emitter) {
            contextData.emitter = this.props.emitter
        }

        return contextData
    }
}

Provider.childContextTypes = {
    //app: PropTypes.object.isRequired,
    emitter: PropTypes.object
};

export default Provider


// WEBPACK FOOTER //
// ./js/caseconfigurator/components/Provider.jsx